import React from 'react';

function findWithRegex(text, regex, callback) {
  let matchArr, start;
  while ((matchArr = regex.exec(text)) !== null) {
    start = matchArr.index;
    callback(start, start + matchArr[0].length);
  }
}
const headersRegEx = /{\$h\d}.*?{\$h}/g;
const headersMarkdownStrategy = (contentBlock, callback) => {
  findWithRegex(contentBlock.getText(), headersRegEx, callback);
};
const Headers = ({ children, hideMarkdown, decoratedText }) => {
  const sliceElementText = (element, start, end) => {
    if (typeof element === "string") {
      return element.slice(start, end);
    } else if (element.props && element.props.text) {
      const text = element.props.text.slice(start, end);
      return React.cloneElement(element, { text });
    } else {
      return element;
    }
  };
  const Type = decoratedText.match(/h\d/)[0];
  if (hideMarkdown) {
    const lastIndex = children.length - 1;
    children[0] = sliceElementText(children[0], 5);
    children[lastIndex] = sliceElementText(children[lastIndex], 0, -4);
  }
  return /* @__PURE__ */ React.createElement(Type, null, children);
};

const HEADERS_MARKDOWN_TYPE = "wix-draft-plugin-headers-markdown";

const DEFAULTS = {
  config: {},
  configViewer: {
    hideMarkdown: true
  }
};

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const createHeadersMarkdownDecorator = (config) => {
  const { [HEADERS_MARKDOWN_TYPE]: settings = {} } = config;
  return {
    strategy: headersMarkdownStrategy,
    component: (props) => Headers(__spreadValues(__spreadValues({}, props), settings))
  };
};
const pluginHeadersMarkdown = (config) => {
  const pluginConfig = __spreadValues(__spreadValues({}, DEFAULTS.configViewer), config);
  return {
    config: pluginConfig,
    type: HEADERS_MARKDOWN_TYPE,
    decorator: (theme, config2) => createHeadersMarkdownDecorator({ [HEADERS_MARKDOWN_TYPE]: __spreadValues({}, config2) })
  };
};

export { createHeadersMarkdownDecorator, pluginHeadersMarkdown };
//# sourceMappingURL=viewer.js.map
